import 'core-js/stable/index.js';
import 'core-js/es/index.js';
import 'core-js/stable/index.js';
import 'core-js/es/index.js';
import "regenerator-runtime/runtime.js";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App.js';
import * as serviceWorker from './serviceWorker.js';
import configureAppStore from './store/index.js';

import './index.css';
import './vpCustomBootstrap.scss';

const store = configureAppStore();
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>, document.getElementById('vendor-portal-container')
);

serviceWorker.unregister();

export default store;